export enum EPoolType {
  EPT_Undefined,
  EPT_StaticMesh,
  EPT_InstanceMesh,
  EPT_Light,
  EPT_Component,
}
